module.exports = __webpack_public_path__ + "static/media/red3.65d61da0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/baby/red3.svg
// module id = 1338
// module chunks = 31